/* Roos clone — mobile footer accordions (reference: Impulse footer on mobile).
   Each footer heading becomes a toggle; its following element is the panel. */
(function () {
  function init() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.footer .footer-block__heading').forEach(function (h) {
      if (h.classList.contains('rv-footer-toggle')) return;
      var panel = h.nextElementSibling;
      if (!panel) return;
      h.classList.add('rv-footer-toggle');
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
      panel.classList.add('rv-footer-panel');
      var wrap = h.parentElement;
      function toggle() {
        var open = wrap.classList.toggle('rv-footer-open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

// RV-MNAV: accordion in het mobiele menu (één open tegelijk, zoals Roos/Impulse).
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.rv-mnav__toggle');
  if (!btn) return;
  e.preventDefault();
  var open = btn.getAttribute('aria-expanded') === 'true';
  document.querySelectorAll('.rv-mnav__toggle[aria-expanded="true"]').forEach(function (b) {
    b.setAttribute('aria-expanded', 'false');
    var s = document.getElementById(b.getAttribute('aria-controls')); if (s) s.hidden = true;
  });
  if (!open) {
    btn.setAttribute('aria-expanded', 'true');
    var sub = document.getElementById(btn.getAttribute('aria-controls')); if (sub) sub.hidden = false;
  }
});

// RV-CART: reserveringstimer in de cart-drawer (Roos ctb-timer: 10 min in sessionStorage, begint opnieuw na afloop).
// Zoekt het element elke tick opnieuw op, omdat Dawn de drawer na elke wijziging opnieuw rendert.
(function () {
  var KEY = 'rvCartTimerEnd';
  function tick() {
    var els = document.querySelectorAll('.rv-ctimer');
    if (!els.length) return;
    var mins = parseInt(els[0].dataset.minutes, 10) || 10;
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(KEY, end); } catch (e) {} }
    var left = end - Date.now(), m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
    var clock = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    els.forEach(function (el) { var c = el.querySelector('.rv-ctimer__clock'); if (c) c.textContent = clock; });
  }
  tick(); setInterval(tick, 1000);
})();
